{
    "en": {
        "translation": {
            "Adult crew": "Adult crew",
            "Adult skipper": "Adult skipper",
            "All female crew": "All female crew",
            "All male crew": "All male crew",
            "Attached file": "Attached file",
            "Attached file + Source file": "Attached file + Source file",
            "Available": "Available",
            "Board": "Board",
            "Booked": "Booked",
            "CT": "CT",
            "Confirmed": "Confirmed",
            "Cruiser": "Cruiser",
            "Default": "Default",
            "Deleted": "Deleted",
            "Dropdown value": "Dropdown value",
            "Dropdown value (unique)": "Dropdown value (unique)",
            "ET": "ET",
            "English": "English",
            "Facebook": "Facebook",
            "Female skipper": "Female skipper",
            "Free text value": "Free text value",
            "Free text value (unique)": "Free text value (unique)",
            "Fulfilled": "Fulfilled",
            "Gate": "Gate",
            "Google": "Google",
            "IRC": "IRC",
            "Independent": "Independent",
            "Intent": "Intent",
            "Invalid": "Invalid",
            "Invisible": "Invisible",
            "L": "L",
            "LKRTH": "LKRTH",
            "LYS": "LYS",
            "M": "M",
            "Male skipper": "Male skipper",
            "Monotype": "Monotype",
            "ORC": "ORC",
            "ORC ToD | Costal / Long distance": "ORC ToD | Costal / Long distance",
            "ORC ToD | Windward / Leeward": "ORC ToD | Windward / Leeward",
            "ORC ToT | Costal / Long distance": "ORC ToT | Costal / Long distance",
            "ORC ToT | Windward / Leeward": "ORC ToT | Windward / Leeward",
            "ORC Triple Number High ToD | Costal / Long distance": "ORC Triple Number High ToD | Costal / Long distance",
            "ORC Triple Number High ToD | Windward / Leeward": "ORC Triple Number High ToD | Windward / Leeward",
            "ORC Triple Number High ToT | Costal / Long distance": "ORC Triple Number High ToT | Costal / Long distance",
            "ORC Triple Number High ToT | Windward / Leeward": "ORC Triple Number High ToT | Windward / Leeward",
            "ORC Triple Number Low ToD | Costal / Long distance": "ORC Triple Number Low ToD | Costal / Long distance",
            "ORC Triple Number Low ToD | Windward / Leeward": "ORC Triple Number Low ToD | Windward / Leeward",
            "ORC Triple Number Low ToT | Costal / Long distance": "ORC Triple Number Low ToT | Costal / Long distance",
            "ORC Triple Number Low ToT | Windward / Leeward": "ORC Triple Number Low ToT | Windward / Leeward",
            "ORC Triple Number Medium ToD | Costal / Long distance": "ORC Triple Number Medium ToD | Costal / Long distance",
            "ORC Triple Number Medium ToD | Windward / Leeward": "ORC Triple Number Medium ToD | Windward / Leeward",
            "ORC Triple Number Medium ToT | Costal / Long distance": "ORC Triple Number Medium ToT | Costal / Long distance",
            "ORC Triple Number Medium ToT | Windward / Leeward": "ORC Triple Number Medium ToT | Windward / Leeward",
            "Ongoing": "Ongoing",
            "Pending": "Pending",
            "Port": "Port",
            "Protest committee": "Protest committee",
            "Race committee": "Race committee",
            "Rejected": "Rejected",
            "Reserved": "Reserved",
            "S": "S",
            "Sport": "Sport",
            "Starboard": "Starboard",
            "Suspended": "Suspended",
            "Technical committee": "Technical committee",
            "U12": "U12",
            "U13": "U13",
            "U14": "U14",
            "U15": "U15",
            "U16": "U16",
            "U18": "U18",
            "U19": "U19",
            "U21": "U21",
            "Unconfirmed": "Unconfirmed",
            "Upcoming": "Upcoming",
            "Updated": "Updated",
            "VJDH": "VJDH",
            "Valid": "Valid",
            "XL": "XL",
            "XS": "XS",
            "XXL": "XXL",
            "Yes / No": "Yes / No"
        }
    }
}
